var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
const propsToClassNamesMap = {
    size: {
        sm: 'c-button--sm',
        md: 'c-button--md',
        lg: 'c-button--lg',
    },
    variant: {
        filled: 'c-button__filled',
        basic: 'c-button__basic',
        outline: 'c-button__outline',
    },
    color: {
        primary: '--primary',
        secondary: '--secondary',
        default: '--default',
    },
    disabled: 'is-disabled',
};
const Button = (_a) => {
    var { className, children, onClick, color = 'default', size = 'md', variant = 'filled' } = _a, props = __rest(_a, ["className", "children", "onClick", "color", "size", "variant"]);
    return (_jsx("button", Object.assign({ className: [
            'c-button',
            propsToClassNamesMap.size[size],
            propsToClassNamesMap.variant[variant],
            propsToClassNamesMap.variant[variant] + propsToClassNamesMap.color[color],
            ...className ? [className] : [],
        ].join(' '), onClick: (e) => {
            e.preventDefault();
            return onClick ? onClick(e) : null;
        } }, props, { children: _jsx("span", Object.assign({ className: "c-button__label" }, { children: _jsx("span", Object.assign({ className: "c-button__label-text" }, { children: children })) })) })));
};
export { Button, };
